// Single source of truth for KaziPeople brand + semantic colours consumed by the
// Ant Design ConfigProvider (main.tsx). CSS cannot import TS, so the contract is:
// these values MIRROR the CSS custom properties in index.css (:root / .dark) — this
// file is the canonical reference. Pages read colour through Tailwind tokens or Ant
// design tokens, never raw hexes, so status/brand colour stays consistent everywhere.

export const BRAND = {
  primary: '#F28A3A', // KaziPeople orange (primary-500)
  primaryHover: '#D9711E', // primary-600
  primaryActive: '#B45A18', // primary-700
} as const;

// Semantic status colours — shared with main-app + partner-portal. Flow into Ant's
// `color="success|warning|error"` presets via the tokens below, so StatusTag and every
// status pill resolve to these (never Ant's default #52c41a / #faad14 / #ff4d4f).
export const SEMANTIC = {
  success: '#16A34A',
  warning: '#D97706',
  danger: '#DC2626',
  info: '#2563EB',
} as const;

// Surface colours per theme — cream/white in light, charcoal in dark.
export const SURFACE = {
  light: { layout: '#FBF6F1', container: '#FFFFFF' },
  dark: { layout: '#16181F', container: '#1E212B' },
} as const;

export const RADIUS = 10;
export const FONT_FAMILY = "'Plus Jakarta Sans', system-ui, -apple-system, sans-serif";
